<template>
    <div>
      <div class="modal-overlay" v-if="detayac"></div>
      <div class="container-fluid mt-3">
        <div class="row">
          <div class="col-10"><input type="text" v-model="search" class="form-control" placeholder="Kullanıcı - Personel Ara"> </div>

          <div class="col-2 mt-4">
            <h4 class="" @click="yenikullanici"><i class="fas fa-plus" style="font-size:21px"></i> YENİ PERSONEL</h4></div>

        </div>
      </div>
<Transition name="slide-fade">
  <div class="modals" role="dialog" v-if="detayac">
    <h2 class="text-left h2" style="font-size:17px">Yeni Personel</h2>
    <br>
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">İsim - Soyisim</h2>

          <input type="text" v-model="obje.ad" id="isim" class="form-control">
        </div>
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Kullanıcı Adı</h2>

          <input type="text" v-model="obje.username" class="form-control"></div>
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Şifre</h2>

          <input type="text" v-model="obje.password" class="form-control">
        </div>
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">E-Posta Adresi</h2>

          <input type="text" v-model="obje.mail" class="form-control" ></div>        
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Ekibi</h2>
              <select v-model="obje.ekip" class="form-control">
                <option disabled value="">Seçiniz</option>
                <option
                  v-for="e in ekipOptions"
                  :key="e.id || e.value || e"
                  :value="(e && e.value !== undefined && e.value !== null) ? e.value : e"
                >
                  {{ (e && e.label) ? e.label : ((e && e.name) ? e.name : e) }}
                </option>
              </select>
        </div> 
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Personel Tipi</h2>
            <select v-model="obje.tip" class="form-control" @change="tipsec($event)">
              <option disabled value="">Seçiniz</option>
              <option
                v-for="d in tipOptions"
                :key="d.id || d.value || d"
                :value="(d && d.value !== undefined && d.value !== null) ? d.value : d"
              >
                {{ (d && d.label) ? d.label : ((d && d.name) ? d.name : d) }}
              </option>
            </select>          
        </div>
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Depo</h2>
            <select v-model="obje.depo" class="form-control">
              <option disabled value="">Seçiniz</option>
              <option
                v-for="d in depoOptions"
                :key="d.id || d.value || d"
                :value="(d && d.value !== undefined && d.value !== null) ? d.value : d"
              >
                {{ (d && d.label) ? d.label : ((d && d.name) ? d.name : d) }}
              </option>
            </select>
        </div>        




        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">E-Posta Şifresi</h2>
          <input type="text" v-model="obje.mailPass" class="form-control">
        </div>



      </div>
      <div class="row mt-3">
         <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Telefon</h2>
            <input type="text" v-model="obje.telefon" class="form-control" placeholder="05xx xxx xx xx">          
         </div>

        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Entegre Kodu</h2>
          <input type="text" v-model="obje.entegrekodu" class="form-control">
        </div>
        <div class="col-4">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">İskonto</h2>
          <input type="text" v-model="obje.iskonto" class="form-control" placeholder="İskonto">
        </div>

        <div class="col-3 my-2">
            <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Teklif Boş Satır</h2>
            <select v-model="obje.teklifBosSatir" class="form-control">
              <option disabled value="">Seçiniz</option>
              <option value="1">Evet</option>
              <option value="0" selected>Hayır</option>
            </select>
        </div>

      </div>      
      <div class="row mt-3">
       <div class="col-3 text-right">
          <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Aktif</h2>
            <select v-model="obje.aktif" class="form-control">
            
              <option value="1">Evet</option>
              <option value="0" selected>Hayır</option>
            </select>        
       </div>

        <div class="col-4 text-right" style="margin-top:20px"><button @click="detayac=false" class="btn btn-orange btn-sm text-center w-100"><span class="fs13">İPTAL</span></button></div>
        <div class="col-6 text-right" style="margin-top:20px"><button @click="kayit()" class="btn btn-blue btn-sm text-center d-block w-100"><span class="fs13">{{mode}}</span></button></div>
      </div>            
    </div>
  </div>
</Transition>

  <div class="table">
            <div class="col-12">

              <table class="table table-hover bg-white mt-3" id="tablo">
                <thead style="background:#f2f2f2" >
                  <tr class="fs14">
                    <td>Id</td>
                    <td>İsim</td>
                    <td>Username</td>
                    <td>E-posta</td>
                    <td>Password</td>
                    <td>İskonto</td>
                    <td>Ek</td>

                    <td>Tip</td>

                    <td>Yetki</td>
                    <!-- <td></td>
                    <td></td> -->
                    <td>Düzen</td>
                    <td>Durum</td>


                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(post, index) in filteredList" :key="index">
                    <td>{{ post.id }}</td>
                    <td>{{ $helper.ilkharfBuyuk(post.ad).substring(0, 50) }}</td>
                    <td>{{ post.username }}</td>
                    <td>{{ post.mail }}</td>
                    <td>{{ post.password}}</td>
                    <td>{{ $helper.ilkharfBuyuk(post.iskonto).substring(0, 45) }}</td>
                    <td>{{ post.ekiskonto }} %</td>
                    <td v-if="tipMap[post.tip]">
                      <span
                        class="badge"
                        :style="{ backgroundColor: tipMap[post.tip].badge }"
                      >
                        {{ tipMap[post.tip].label }}
                      </span>
                    </td>                    <!-- <td v-if="post.root==1"><span class="badge badge-danger">Admin</span></td>
                    <td v-else-if="post.id==post.entegrekodu"><span class="badge badge-primary">Müşteri</span></td>
                    <td v-else><span class="badge badge-info">Personel</span></td> -->
              <!-- kullaniciSec(post) -->
                    <td class=""> 
                      <select @change="aktifPersonel(post,$event)" style="padding:1px">

                        <option value="0" selected>Tip Seç</option>
                        <option value="cari">Cari</option>
                        <option value="marka">Marka</option>
                        <option value="depo">Depo</option>
                        <option value="anagrup">Anagrup</option>

                      </select>
                    </td>
                    <td> <i @click="duzen(post)" class="icon-edit" style="font-size:23px;"/> </td>
                    <td v-if="post.aktif==1"><span class="badge badge-success">Aktif</span></td>
                    <td v-else><span class="badge badge-danger">Pasif</span></td>
                    
                    <!-- <td>
                      <router-link to="/kullanici/dashboard"><i class="flaticon-menu-4 text-center" style="font-size:23px;"></i></router-link>
                      
                    </td> -->
                    <!-- <td><i @click="download(post)" class="fas fa-download text-danger"></i></td> -->


                  </tr>
              </tbody>
            </table>
        </div>
  </div>
 </div>
</template>
  
  <script>
  import { router } from '@/router';

  export default {
  data() {
      return {
        posts:[],
        hesap:this.$request.ayar(),
        detayac:false, // stok detay
        show:true,
        search:"",
        obje : {
         id:0,    
         ad:'',
         username:'',
         password:'',
         depo:0, // sabit depo
         ekip:0,
         mail:'',
         mailPass:'',
         aktif:1,
         entegrekodu:0,
         iskonto:"0+0+0",
         ekiskonto:0,
         root:0,
         teklifBosSatir : 0,
         tip:0,
         telefon:''
        },
        mode:'PERSONEL EKLE',
        mesaj:'',
        tipOptions: [
          {
            value: 1,
            label: "Sistem Yöneticisi",
            root: 1,
            badge: "#dc3545" // kırmızı
          },
          {
            value: 2,
            label: "Bölge Müdürü",
            root: 0,
            badge: "#0d6efd" // mavi
          },
          {
            value: 3,
            label: "Ekip Lideri",
            root: 0,
            badge: "#0dcaf0" // açık mavi
          },
          {
            value: 4,
            label: "Saha Personeli",
            root: 0,
            badge: "#6c757d" // gri
          },
          {
            value: 5,
            label: "Müşteri",
            root: 0,
            badge: "#198754" // yeşil
          }
        ] ,
        depoOptions: [],
        ekipOptions: [],
      };
    },
    // },
    computed:{
    filteredList() {
      return this.posts.filter(post => {
        return post.ad.toLowerCase().includes(this.search.toLowerCase())
      })
    } ,

    tipMap () {
        const map = {}
        this.tipOptions.forEach(o => {
          map[o.value] = o
        })
        return map
    }
  },
    created() {
      this.mode = 'EKLE'
      if (this.hesap.tip=="1") { this.$store.setLoading([false,'']); this.getir(); }
      else {
        this.$store.setLoading([false,''])
        this.$router.push("/info")
      }
    },
  
    methods: {
      modul(){ this.$store.showNotify({ type: 'danger', text: `Pasif Modül`, timeout: 1000 }); },
      getir(){
      this.$store.setLoading([true,'Bekleyin'])
        this.$request.post('crm/kullanici/list',this.obje).then(res=>{
          console.log(res)
          if (res.status != 309) {
            this.$store.setLoading([false,''])
            this.posts = res;
          }
          else{
            this.$router.push("/oturum")
          }
        }).catch((err)=>{
            this.$store.setLoading([false,''])
            this.$store.showNotify({ type: 'danger', text: err.message, timeout: 3000 });
        })         
      },
      kayit(){
      this.$store.setLoading([true,'Bekleyiniz'])
        if (this.mode == 'EKLE') {
          this.yeni();
        }
        else{
          this.duzenle();
        }
      },
      yenikullanici(){
        this.mode = 'EKLE';
        this.obje.ad='',
        this.obje.username='',
        this.obje.telefon='',

        this.obje.password='',
        this.obje.depo=0,
        this.obje.ekip=0,
        this.obje.teklifBosSatir = 0
        this.obje.mail='',
        this.obje.mailPass='',
        this.obje.aktif=true,
        this.obje.entegrekodu=false
        this.detayac = true
        this.obje.iskonto="0+0+0",
        this.obje.ekiskonto=0,
        this.obje.root=0
      },
      yeni(){
        if (this.obje.tip == 1 ) this.hesap.root = 1
        var _ = this.obje
        if (_.ad == '' || _.username == '' || _.password == '' || _.tip == 0 || _.tip == '') {
          this.$store.setLoading([false,''])
          this.$store.showNotify({ type: 'danger', text: "Yıldızlı Alanları Doldur", timeout: 3000 });
        }
        else 
        {
        this.detayac = true;
        this.$request.post('crm/kullanici/add',this.obje).then(res=>{
          console.log(res)
          if (res.status != 309) {
            this.getir()
            this.detayac = false;
            this.$store.setLoading([false,''])
            this.$store.showNotify({ type: 'success', text: res.msg, timeout: 3000 });
          }
          else{
            this.$router.push("/oturum")
          }
        }).catch((err)=>{
            this.$store.setLoading([false,''])
            this.$store.showNotify({ type: 'danger', text: err.message, timeout: 3000 });

        })           
        }
 
      },
      duzen(obj){
      
        this.mode='DÜZENLE';
        this.obje.ad=obj.ad,
        this.obje.username=obj.username,
        this.obje.password=obj.password,

        this.obje.depo=0,
        this.obje.ekip=0,
        this.obje.telefon=obj.telefon,
        this.obje.tip=obj.tip,
        this.obje.teklifBosSatir = obj.teklifBosSatir
        this.obje.entegrekodu = obj.entegrekodu
        this.obje.mail=obj.mail,
        this.obje.mailPass=obj.mailPass,
        this.obje.id = obj.id,
        this.obje.iskonto=obj.iskonto,
        this.obje.ekiskonto=obj.ekiskonto,
        this.obje.root=obj.root
        this.detayac = true
        
      },
      duzenle(){
        if (this.obje.tip == 1 ) this.hesap.root = 1
        this.$request.post('crm/kullanici/update',this.obje,this.hesap).then(res=>{
          if (res.status != 309) {
            this.getir()
            this.detayac = false;
            this.$store.setLoading([false,''])
            this.$store.showNotify({ type: 'success', text:res.msg, timeout: 3000 });
          }
          else{
            this.$router.push("/oturum")
          }
        })
        .catch((err)=>{
          this.$store.setLoading([false,''])
          this.$store.showNotify({ type: 'danger', text: err.message, timeout: 3000 });
        })  
      },
      close(){
        this.detayac = false
      },
      tipsec(event) {
       if (event.target.value ==1) this.obje.entegrekodu = false;
       if (event.target.value ==2) this.obje.entegrekodu = true
       if (event.target.value ==5) {
        this.$store.showNotify({ type: 'danger', text: "Bu alanda Müşteri Seçilemez", timeout: 3000 

        });
                this.obje.tip  = 0

       }
      },
      aktifPersonel: function (personel,event) {
        // cari: { id, isim } gibi
        const item =  this.tipOptions.find(x => x.value === personel.tip);
        var payload = {
          id: personel.id,
          isim: personel.ad,
          tip:item.label
        }
        localStorage.setItem('aktifPersonel', JSON.stringify(payload))
        setTimeout(() => {
          if (event.target.value == "cari") {
            this.$router.push("/kullanici/yetki")
          }
          else {
           this.$router.push("/stok/yetki/"+event.target.value)
          }

        }, 500);
      }      
    },
  };
  </script>
  <style scoped>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
    .modals {
      position: absolute;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      text-align: center;
      width: fit-content;
      height: fit-content;
      max-width: 222em;
      min-width: 50%;
      padding: 2rem 2rem 1rem 2rem;
      border-radius: 1rem;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
      background: #FFF;
      z-index: 999999999;
      transform: none;
    }
    .modals h1 {
      margin: 0 0 1rem;
    }
    
    .modal-overlay {
      content: '';
      position: absolute;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99;
      background: #000;
      opacity: 0.6;
      cursor: pointer;
    }
/* -------------------------------------------------------
   Bootstrap YOK: row/col/table/badge sınıflarını biz veriyoruz
-------------------------------------------------------- */

/* Genel */
.container-fluid{ width:100%; padding:0 12px; }
.mt-3{ margin-top:12px; }
.mt-4{ margin-top:16px; }
.pt-2{ padding-top:8px; }
.text-left{ text-align:left; }
.text-right{ text-align:right; }
.w-100{ width:100%; }
.d-block{ display:block; }
.bg-white{ background:#fff; }
.fs13{ font-size:13px; }
.fs14{ font-size:14px; }

/* Basit form-control */
.form-control{
  width:100%;
  height:46px;
  padding:0 12px;
  border:1px solid #e6e9ef;
  border-radius:10px;
  outline:none;
  background:#fff;
}
.form-control:focus{
  border-color:#cbd5e1;
  box-shadow:0 0 0 3px rgba(148,163,184,.25);
}

/* Row/Col sistemi (bootstrap yerine) */
.row{
  display:flex;
  flex-wrap:wrap;
  gap:12px;
  align-items:flex-start;
}

/* Varsayılan: 12 kolon sistemi gibi düşün */
.col-1{ flex:0 0 calc(8.333% - 12px); }
.col-2{ flex:0 0 calc(16.666% - 12px); }
.col-3{ flex:0 0 calc(25% - 12px); }
.col-4{ flex:0 0 calc(33.333% - 12px); }
.col-6{ flex:0 0 calc(50% - 12px); }
.col-10{ flex:0 0 calc(83.333% - 12px); }
.col-12{ flex:0 0 100%; }

/* Dar ekranlarda üst arama alanı + yeni kullanıcı satırı */
@media (max-width: 900px){
  .col-10{ flex:0 0 100%; }
  .col-2{ flex:0 0 100%; }
  .col-2.mt-4{ margin-top:0; }
  .col-2 h4{ padding:10px 12px; border:1px solid #e6e9ef; border-radius:10px; background:#fff; }
}

/* -------------------------------------------------------
   MODAL
-------------------------------------------------------- */
.modal-overlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,.45);
  z-index:999998;
}

.modals{
  position:fixed;
  left:50%;
  top:50%;
  transform:translate(-50%,-50%);
  width:min(1200px, 96vw);  /* 4’lü satırlar için geniş */
  max-height:92vh;
  overflow:auto;
  background:#fff;
  border-radius:12px;
  z-index:999999;
  box-shadow:0 18px 60px rgba(0,0,0,.25);
  padding:14px 16px 16px 16px;
}

/* Modal başlık */
.modals > .h2{
  margin:0 0 10px 0;
  font-weight:700;
}

/* Modal içindeki 4’lü alanlar: senin col-4 blokların yan yana gelsin */
.modals .row.mt-3{
  /* bootstrap yokken 3’lü/4’lü kontrol burada */
  gap:12px;
}

/* Senin modalında "col-4" kullanıyorsun; biz bunu 4’lüye çeviriyoruz */
.modals .col-4{
  flex:0 0 calc(25% - 12px); /* 4’lü */
}

/* Switch ve buton satırındaki kolonlar daha dengeli */
.modals .col-1{ flex:0 0 auto; }
.modals .col-2{ flex:0 0 auto; min-width:120px; }
.modals .col-3{ flex:0 0 calc(25% - 12px); }

/* Mobilde modal: satırlar 2’li, en dar’da 1’li */
@media (max-width: 900px){
  .modals .col-4{ flex:0 0 calc(50% - 12px); } /* 2’li */
  .modals .col-3{ flex:0 0 100%; }
}
@media (max-width: 520px){
  .modals .col-4{ flex:0 0 100%; } /* 1’li */
}

/* -------------------------------------------------------
   BUTONLAR
-------------------------------------------------------- */
.btn{
  height:44px;
  border:0;
  border-radius:10px;
  padding:0 14px;
  font-weight:700;
  cursor:pointer;
  color:#fff;
}
.btn-orange{ background:#f59e0b; }
.btn-blue{ background:#1d4ed8; }

/* -------------------------------------------------------
   TABLO (PC)
-------------------------------------------------------- */
.table{ margin-top:10px; }
.table > .col-12{ width:100%; }

/* PC’de tablo container scroll destekli (dar ekranlarda yatay taşma) */
#tablo{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  background:#fff;
  border:1px solid #e6e9ef;
  border-radius:10px;
  overflow:hidden;
  min-width:1100px; /* çok kolon var */
}

#tablo thead td{
  font-weight:800;
  font-size:13px;
  padding:12px 12px;
  border-bottom:1px solid #e6e9ef;
  background:#f2f2f2;
  white-space:nowrap;
}

#tablo tbody td{
  padding:12px 12px;
  border-bottom:1px solid #eef2f7;
  font-size:14px;
  white-space:nowrap;
}

#tablo tbody tr:hover{ background:#fbfcfe; }

/* Tabloyu saran alan yatay kaydırılabilir olsun */
.table .col-12{
  overflow:auto;
  border-radius:10px;
}

/* -------------------------------------------------------
   BADGE (bootstrap yok)
-------------------------------------------------------- */
.badge{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding:3px 10px;
  height:22px;
  border-radius:6px;
  font-size:12px;
  font-weight:800;
  color:#fff;
}
.badge-danger{ background:#e11d48; }
.badge-success{ background:#16a34a; }
.badge-primary{ background:#2563eb; }
.badge-info{ background:#64748b; }

/* -------------------------------------------------------
   MOBİL TABLO: satırları kart gibi göster (thead gizle)
   (Template’e data-label eklemeden nth-child ile etiket basıyoruz)
-------------------------------------------------------- */
@media (max-width: 900px){
  /* Yatay scroll yerine kart görünüm istersen bunu açıyoruz */
  #tablo{ min-width:0; border:none; }
  #tablo thead{ display:none; }
  #tablo, #tablo tbody, #tablo tr, #tablo td{ display:block; width:100%; }
  #tablo tr{
    background:#fff;
    border:1px solid #e6e9ef;
    border-radius:12px;
    margin:10px 0;
    overflow:hidden;
  }
  #tablo td{
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:12px;
    padding:10px 12px;
    border-bottom:1px solid #eef2f7;
    white-space:normal;
  }
  #tablo td:last-child{ border-bottom:none; }

  /* Başlıklar (kolon sırasına göre) */
  #tablo td:nth-child(1)::before{ content:"Id"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(2)::before{ content:"İsim"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(3)::before{ content:"Username"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(4)::before{ content:"E-posta"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(5)::before{ content:"Password"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(6)::before{ content:"İskonto"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(7)::before{ content:"Ek"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(8)::before{ content:"Tip"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(9)::before{ content:"Yetki"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(10)::before{ content:"Aktif"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(11)::before{ content:"Düzenle"; font-weight:800; color:#6b7280; }
  #tablo td:nth-child(12)::before{ content:"Panel"; font-weight:800; color:#6b7280; }
}

/* -------------------------------------------------------
   Transition (mevcut slide-fade ismine uygun)
-------------------------------------------------------- */
.slide-fade-enter-active{ transition: all .18s ease; }
.slide-fade-leave-active{ transition: all .12s ease; }
.slide-fade-enter, .slide-fade-leave-to{
  opacity:0;
  transform: translate(-50%,-46%);
}

  </style>
  
  


// WEBPACK FOOTER //
// src/views/kullanici/list.vue